// resources/js/tracking/review-trigger.js
//
// Déclenche le modal d'avis sur la carte après 3 clics champignons.
// Conditions : abonné actif + website avec Trustpilot + pas déjà noté + pas de cooldown.

const CLICK_KEY      = 'mh_review_click_count';
const REVIEWED_KEY   = 'mh_reviewed';
const DISMISSED_KEY  = 'mh_review_dismissed_at';
const DISMISS_CT_KEY = 'mh_review_dismiss_count';
const CLICK_THRESHOLD = 3;
const COOLDOWN_DAYS   = 14;
const DISMISS_LIMIT   = 3;

let triggerTimer = null;

function getConfig() {
    return window.reviewConfig || {};
}

function isBlocked() {
    const cfg = getConfig();
    if (!cfg.hasTrustpilot)   return true;
    if (!cfg.isSubscriber)    return true;
    if (cfg.alreadyReviewed)  return true;
    if (localStorage.getItem(REVIEWED_KEY) === 'true') return true;

    const dismissedAt = localStorage.getItem(DISMISSED_KEY);
    if (dismissedAt) {
        const days = (Date.now() - new Date(dismissedAt).getTime()) / (1000 * 60 * 60 * 24);
        if (days < COOLDOWN_DAYS) return true;
    }
    return false;
}

function getClickCount() {
    return parseInt(sessionStorage.getItem(CLICK_KEY) || '0', 10);
}

function incrementClickCount() {
    const next = getClickCount() + 1;
    sessionStorage.setItem(CLICK_KEY, String(next));
    return next;
}

export function onMushroomClicked() {
    if (isBlocked()) return;

    const count = incrementClickCount();
    if (count !== CLICK_THRESHOLD) return;

    if (triggerTimer) clearTimeout(triggerTimer);

    triggerTimer = setTimeout(() => {
        triggerTimer = null;
        if (isBlocked()) return;
        showModal();
    }, 30_000);
}

function showModal() {
    const el = document.getElementById('reviewModal');
    if (!el || typeof bootstrap === 'undefined') return;
    const instance = bootstrap.Modal.getInstance(el) || new bootstrap.Modal(el);
    instance.show();
}

export function init() {
    const el = document.getElementById('reviewModal');
    if (!el) return;

    el.addEventListener('hidden.bs.modal', () => {
        if (localStorage.getItem(REVIEWED_KEY) === 'true') return;
        localStorage.setItem(DISMISSED_KEY, new Date().toISOString());
        const ct = parseInt(localStorage.getItem(DISMISS_CT_KEY) || '0', 10) + 1;
        localStorage.setItem(DISMISS_CT_KEY, String(ct));
        if (ct >= DISMISS_LIMIT) {
            localStorage.setItem(REVIEWED_KEY, 'true');
        }
    });

    const cfg = getConfig();
    const tpBtn = document.getElementById('review-tp-btn');
    if (tpBtn && cfg.trustpilotUrl) {
        tpBtn.href = cfg.trustpilotUrl;
    }

    const ctaBtn = document.getElementById('review-cta-btn');
    if (ctaBtn && cfg.trustpilotUrl) {
        ctaBtn.href = cfg.trustpilotUrl;
    }

    const cards = Array.from(el.querySelectorAll('.star-card'));
    const starRow = el.querySelector('#review-modal-star-row');

    function setHighlight(upTo) {
        cards.forEach(card => {
            const icon = card.querySelector('.star-icon');
            if (parseInt(card.dataset.rating) <= upTo) {
                icon.style.color = '#FFD700';
                icon.style.transform = 'scale(1.15)';
            } else {
                icon.style.color = '#ccc';
                icon.style.transform = '';
            }
        });
    }

    cards.forEach(card => {
        card.addEventListener('mouseenter', () => setHighlight(parseInt(card.dataset.rating)));
    });
    if (starRow) {
        starRow.addEventListener('mouseleave', () => setHighlight(0));
    }
}

window.ReviewModal = {
    submitRating(rating) {
        const cfg = getConfig();
        const cards = Array.from(document.querySelectorAll('#reviewModal .star-card'));

        function setHighlight(upTo) {
            cards.forEach(card => {
                const icon = card.querySelector('.star-icon');
                if (parseInt(card.dataset.rating) <= upTo) {
                    icon.style.color = '#FFD700';
                    icon.style.transform = 'scale(1.15)';
                } else {
                    icon.style.color = '#ccc';
                    icon.style.transform = '';
                }
            });
        }
        setHighlight(rating);

        setTimeout(() => {
            fetch(cfg.storeUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': cfg.csrfToken,
                },
                body: JSON.stringify({ rating }),
            })
            .then(r => r.json())
            .then(data => {
                if (data.next === 'trustpilot') {
                    document.getElementById('review-step-rate').style.display = 'none';
                    document.getElementById('review-step-trustpilot').style.display = '';
                } else {
                    window._reviewModalReviewId = data.review_id;
                    document.getElementById('review-step-rate').style.display = 'none';
                    document.getElementById('review-step-feedback').style.display = '';
                }
            })
            .catch(() => {});
        }, 180);
    },

    submitFeedback() {
        const cfg = getConfig();
        const text = document.getElementById('review-feedback-text').value.trim();
        if (!text) return;

        fetch(cfg.storeFeedbackUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': cfg.csrfToken,
            },
            body: JSON.stringify({ feedback: text }),
        })
        .then(r => r.json())
        .then(data => {
            if (data.success) {
                localStorage.setItem(REVIEWED_KEY, 'true');
                document.getElementById('review-feedback-text').style.display = 'none';
                document.querySelector('#reviewModal .review-modal-submit-btn').style.display = 'none';
                document.getElementById('review-feedback-thanks').style.display = '';
                setTimeout(() => {
                    const el = document.getElementById('reviewModal');
                    if (el && bootstrap) {
                        const instance = bootstrap.Modal.getInstance(el);
                        if (instance) instance.hide();
                    }
                }, 2000);
            }
        })
        .catch(() => {});
    },
};
